import { Navigate, Outlet } from 'react-router';
import { useSession } from '@/entities/session/hooks/use-session';

export function RequireSession() {
  const session = useSession();
  if (!session) return <Navigate to="/sign-in" replace />;
  return <Outlet />;
}
